import { render, staticRenderFns } from "./NotificationListCard.vue?vue&type=template&id=b3066a96&scoped=true"
import script from "./NotificationListCard.vue?vue&type=script&lang=js"
export * from "./NotificationListCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationListCard.vue?vue&type=style&index=0&id=b3066a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3066a96",
  null
  
)

export default component.exports